var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.38371 1.21768C10.1825 0.12165 11.8175 0.121648 12.6163 1.21768L14.9853 4.46812C15.2328 4.8078 15.5811 5.06085 15.9807 5.19133L19.8041 6.43992C21.0933 6.86094 21.5985 8.41587 20.803 9.51427L18.4437 12.7717C18.1971 13.1122 18.0641 13.5216 18.0635 13.9419L18.0575 17.964C18.0555 19.3203 16.7328 20.2813 15.4423 19.8641L11.6152 18.6269C11.2153 18.4976 10.7847 18.4976 10.3848 18.6269L6.5577 19.8641C5.26722 20.2813 3.94451 19.3203 3.9425 17.964L3.93651 13.9419C3.93589 13.5216 3.80285 13.1122 3.5563 12.7717L1.197 9.51428C0.40146 8.41587 0.906687 6.86094 2.19592 6.43992L6.01932 5.19133C6.41888 5.06085 6.76718 4.8078 7.01474 4.46812L9.38371 1.21768Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.f5b6daed1a7a8c92818d989030576e93.svg";
export { ForwardRef as ReactComponent };